import { AadhaarVerify } from "./containers";

export default AadhaarVerify
